<template>
    <div class="planningContent">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "planningContent",
    components: {
    },
    data() {
        return {
        }
    }
}
</script>
<style scoped lang="less">
.planningContent {
}
</style>